var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "#B1924C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 4.44141L4.01361 12.5693C4.01361 12.5808 4.01069 12.5977 4.00485 12.6207C3.99914 12.6435 3.99609 12.6601 3.99609 12.6718V20.9022C3.99609 21.1994 4.10614 21.4569 4.32616 21.6738C4.54612 21.8908 4.8066 22 5.10764 22H11.7765V15.4155H16.223V22.0002H22.8917C23.1927 22.0002 23.4536 21.8913 23.6732 21.6738C23.8932 21.4572 24.0036 21.1995 24.0036 20.9022V12.6718C24.0036 12.6262 23.9973 12.5917 23.9861 12.5693L13.9997 4.44141Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8069 10.717L24.0036 7.59623V0.600278C24.0036 0.440344 23.9516 0.308817 23.8471 0.205878C23.7434 0.103059 23.6102 0.0516497 23.4478 0.0516497H20.1134C19.9512 0.0516497 19.818 0.103059 19.7137 0.205878C19.6096 0.308817 19.5576 0.440404 19.5576 0.600278V3.94388L15.3201 0.445809C14.95 0.148583 14.5099 0 14.0004 0C13.491 0 13.051 0.148583 12.6805 0.445809L0.192987 10.717C0.0772274 10.8082 0.0137815 10.9311 0.00198048 11.0855C-0.00975975 11.2397 0.0306923 11.3744 0.123458 11.4886L1.20021 12.7575C1.29298 12.8604 1.4144 12.9232 1.56495 12.9462C1.70395 12.9578 1.84295 12.9177 1.98194 12.8262L14 2.9322L26.0183 12.8262C26.1111 12.9059 26.2325 12.9458 26.383 12.9458H26.4352C26.5855 12.9232 26.7067 12.8599 26.7999 12.7573L27.8768 11.4886C27.9694 11.3741 28.01 11.2396 27.9979 11.0852C27.9861 10.9313 27.9224 10.8084 27.8069 10.717Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRounded);
export default __webpack_public_path__ + "static/media/home-rounded.959929af0e121d22f7e13d18e5b14744.svg";
export { ForwardRef as ReactComponent };